export type UiThemeTokens = {
  colorPrimary: string;
  colorSuccess: string;
  colorWarning: string;
  colorError: string;
  colorBgBase: string;
  colorTextBase: string;
  borderRadius: number;
  borderRadiusLG: number;
  controlHeight: number;
  controlHeightLG: number;
  fontFamily: string;
};

export const uiThemeTokens: UiThemeTokens = {
  colorPrimary: "#0ebfff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorBgBase: "#ffffff",
  colorTextBase: "#1a1a1a",
  borderRadius: 8,
  borderRadiusLG: 12,
  controlHeight: 40,
  controlHeightLG: 48,
  fontFamily:
    "Manrope, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};
